export const validatorLikePhone = phone => {
  /* eslint-disable no-useless-escape */
  const regExp = /^[\+][(]?[0-9]{1,3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,9}$/
  return regExp.test(phone.replace(/\s/g, ''))
}

export const validatorTextNumSpaceDash = text => {
  /* eslint-disable no-useless-escape */
  const regExp = /^[^!@#$%^&*():;"'`\[\]{}\\/|,~+_]{0,}$/
  return regExp.test(text)
}
